import styled from 'styled-components';

export const Container = styled.div`
  .bg-ferramentas {
    background-color: #01888b;
  }
  .btn-course {
    background: rgba(255, 255, 255, 0.2);
  }

  p {
    font-size: 16px;
    color: #000000;
  }

  button {
    font-size: 16px;
  }

  .page {
    height: 700px !important;
  }
`;
